import {combineReducers} from "redux";

// import reducers
import general from './general';
import service from './service'
import utils from "./utils";
import contact from "./contact"
import about from "./about";
import news from "./news";

export default combineReducers({
    general,
    utils,
    service,
    contact,
    about,
    news
});
